import React, { useEffect, useState } from 'react'
import { Edit, useForm, BooleanField, Create, Breadcrumb, SaveButton } from '@refinedev/antd';
import { Form, Input, Checkbox, FormProps } from 'antd';
import { useSchemaDB } from 'hooks/useSchemaDB';
import { FieldDB, TableDB } from 'interfaces/schemaDB';
import Cw8Form from './Cw8Form';
import { CrudFilters } from '@refinedev/core/dist/interfaces';
import { FormMode } from 'interfaces/interfaces';
import { useNavigation } from '@refinedev/core';
import { ArrowLeftOutlined } from '@ant-design/icons';
// import { useNavigation } from 'react-router-dom';


interface Cw8CreateProps {
    resourceName: string
    filterList?: CrudFilters
    createFormProps?: FormProps
    isModal ?: boolean
    closeModal ?: () => void;
    onFinish ?: (values:any) => void;
}

const Cw8Create = ({resourceName, filterList, createFormProps, isModal, closeModal, onFinish}: Cw8CreateProps) => {

    const { goBack } = useNavigation();
    const { form, formProps, saveButtonProps, queryResult, redirect 
    } = useForm( {
        resource: resourceName,
        action: "create"
        , redirect : false
        , onMutationSuccess: (data, variables, context) => {
            if(isModal && closeModal){
                closeModal()
            }else{
                goBack()
            }
        }        
    });


    const {schemaDBState,  getTable, getCreateField  } = useSchemaDB({nameTable:resourceName})


    const table = getTable(resourceName)
    const fieldList = getCreateField(table?table?.length>0?table[0]:null:null) 

    // console.log(filterList)

    return (

        //is child
        filterList && !isModal?(
            <>
            {/* <p>456</p> */}
            <Cw8Form
                fieldList = {fieldList}
                formProps = {createFormProps?createFormProps:formProps}
                filterList= {filterList}
                formMode =  {FormMode.create}
                resourceName = {resourceName}
                form = {form}
                onFinish = {onFinish}
            ></Cw8Form>            
            </>
        ):(
            //se debe añadir este create para que se tomen los valores de los campos en el formy se envíen
            <Create  
                saveButtonProps={saveButtonProps}
                // saveButtonProps={ {onClick : ()=> {console.log("CREATE")}} }
                breadcrumb={isModal?<></>:<Breadcrumb />}
            >
                <Cw8Form
                    fieldList = {fieldList}
                    formProps = {formProps}
                    // formProps = {createFormProps?createFormProps:formProps} //si se deja esto, los valores del filtro no se recargan
                    filterList= {filterList}
                    formMode =  {FormMode.create}
                    resourceName = {resourceName}
                    form = {form}
                ></Cw8Form>
            </Create>
        )

    )
}

export default Cw8Create
